export default "__VITE_ASSET__BXq_y1fY__"